module.exports = __webpack_public_path__ + "img/icon_coffee-bean.3b0f42e1.svg";